import React, { useState } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { businessInfo } from "../data/mock";
import "../styles/Contact.css";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: ""
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: `Treatment of Interest: ${formData.service}\n\n${formData.message}`
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitted(true);
        setTimeout(() => {
          setSubmitted(false);
          setFormData({ name: "", email: "", phone: "", service: "", message: "" });
        }, 5000);
      } else {
        throw new Error(data.detail || "Failed to submit form");
      }
    } catch (err) {
      console.error("Form submission error:", err);
      setError("Failed to send message. Please try calling or emailing us directly.");
      setTimeout(() => setError(null), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section section-padding">
      <div className="container">
        <div className="contact-header">
          <h2 className="hero-medium">Book Your Consultation</h2>
          <p className="body-large">
            Ready to begin your journey? Get in touch with us today
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-info-item">
              <Phone size={20} />
              <div>
                <h3 className="heading-3">Phone</h3>
                <a href={`tel:${businessInfo.phone}`} className="body-regular contact-link">
                  {businessInfo.phone}
                </a>
              </div>
            </div>

            <div className="contact-info-item">
              <Mail size={20} />
              <div>
                <h3 className="heading-3">Email</h3>
                <a href={`mailto:${businessInfo.email}`} className="body-regular contact-link">
                  {businessInfo.email}
                </a>
              </div>
            </div>

            <div className="contact-info-item">
              <MapPin size={20} />
              <div>
                <h3 className="heading-3">Address</h3>
                <p className="body-regular">{businessInfo.address}</p>
              </div>
            </div>

            <div className="contact-info-item">
              <Clock size={20} />
              <div>
                <h3 className="heading-3">Opening Hours</h3>
                <p className="body-regular">{businessInfo.hours.weekday}</p>
                <p className="body-regular">{businessInfo.hours.saturday}</p>
                <p className="body-regular">{businessInfo.hours.sunday}</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="body-small">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="body-small">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone" className="body-small">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="service" className="body-small">Treatment of Interest</label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                className="form-input"
              >
                <option value="">Select a treatment</option>
                <option value="IV Infusions">IV Infusions</option>
                <option value="Botox & Anti-Wrinkle">Botox & Anti-Wrinkle</option>
                <option value="IM Injections">IM Injections</option>
                <option value="Specialized Treatments">Specialized Treatments</option>
                <option value="Consultation">General Consultation</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message" className="body-small">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                className="form-input"
              ></textarea>
            </div>

            {error && (
              <div className="form-error body-small">
                {error}
              </div>
            )}

            {submitted && (
              <div className="form-success body-small">
                Thank you! We'll get back to you soon.
              </div>
            )}

            <button type="submit" className="btn-primary" disabled={submitted || isSubmitting}>
              {isSubmitting ? "Sending..." : submitted ? "Message Sent!" : "Send Inquiry"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
